import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';

/**
 * Fetches all roles. If you have to fetch roles which are supported by an Organization, use fetchOrgRolesTE.
 * @param params types, page, perPage - endpoint supports these params
 */
export const fetchRolesTE = <E = CF.API.ApiError>(
  params?: string,
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.Organizations.ListRolesResponse> =>
  fetchTE<CF.API.Organizations.ListRolesResponse, E>(
    {
      path: `/api/_api/v2/roles${params ? `?${params}` : ''}`,
      method: 'GET',
    },
    onRejected,
  );

/**
 * Fetches all roles supported by an Organization.
 */
export const fetchOrgRolesTE = <E = CF.API.ApiError>(
  { orgId, params }: { orgId: string; params?: string },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.Organizations.ListRolesResponse> =>
  fetchTE<CF.API.Organizations.ListRolesResponse, E>(
    {
      path: `/api/_api/v2/organizations/${orgId}/roles${params ? `?${params}` : ''}`,
      method: 'GET',
    },
    onRejected,
  );
